/**
 * Import custom GTM scripts here.
 *
 * @see {@link ./gtm-scripts}
 */
import formStarts from './gtm-scripts/_form-starts.js';
import formFails from './gtm-scripts/_form-fails.js';

/**
 * Checks if Google Tag Manager is loaded.
 *
 * @returns {boolean} - Returns true if GTM is loaded, otherwise false.
 */
function isGtmLoaded() {
	return typeof window.google_tag_manager !== "undefined";
}

/**
 * Initializes all GTM-related scripts.
 *
 * @function
 * @name gtmScripts
 */
export default function gtmScripts() {
	if (isGtmLoaded()) {
		/**
		 * Include custom GTM scripts.
		 */
		formStarts();
		formFails()
	}
}

if ( [ 'interactive', 'complete' ].includes( document.readyState ) ) {
	gtmScripts();
} else {
	document.addEventListener( 'DOMContentLoaded', gtmScripts );
}
